import { defineStore } from 'pinia'
import axios from '@/services'

export const useFundsCategoryStore = defineStore('funds-category', {
  modelName: 'FundCategory',
  state: () => ({
    fundsCategories: [],
    loading: false
  }),
  
  getters: {
    showFundsCategories: (state) => state.fundsCategories
  },
  
  actions: {
    onModelChanged() {
      this.getFundsCategories()
    },

    async getFundsCategories() {
      try {
        this.loading = true
        const response = await axios.get('/api/fundsCategories/fundsCategories')
        this.fundsCategories = response.data.data
      } catch (error) {
        this.fundsCategories = []
        console.error('Error fetching funds categories:', error)
      } finally {
        this.loading = false
      }
    },

    async fetchFundCategory(id) {
      try {
        this.loading = true
        const response = await axios.get(`/api/fundsCategories/view/${id}`)
        return response.data.data
      } catch (error) {
        console.error('Error fetching fund category:', error)
        throw error
      } finally {
        this.loading = false
      }
    },

    async createFundCategory(categoryData) {
      try {
        this.loading = true
        const response = await axios.post('/api/fundsCategories/add', categoryData)
        return response.data
      } catch (error) {
        console.error('Error creating fund category:', error)
        throw error
      } finally {
        this.loading = false
      }
    },

    async updateFundCategory(id, categoryData) {
      try {
        this.loading = true
        const response = await axios.post(`/api/fundsCategories/edit/${id}`, categoryData)
        return response.data
      } catch (error) {
        console.error('Error updating fund category:', error)
        throw error
      } finally {
        this.loading = false
      }
    }
  }
})